module.exports = __webpack_public_path__ + "static/img/fiveth.8b5bd1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fiveth.png
// module id = 7rno
// module chunks = 1